import { render, staticRenderFns } from "./SizeRecommendationSizeFeedbacks.vue?vue&type=template&id=6821699b&scoped=true"
import script from "./SizeRecommendationSizeFeedbacks.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationSizeFeedbacks.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationSizeFeedbacks.vue?vue&type=style&index=0&id=6821699b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6821699b",
  null
  
)

/* custom blocks */
import block0 from "./SizeRecommendationSizeFeedbacks.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports